import { types } from 'mobx-state-tree'
import { IdNamePair } from './collection'

export const AnimationTypes = types.model({
   items: types.optional(types.array(IdNamePair), []),
   totalCount: types.optional(types.number, 0),
})
